export default function unsetGrabCursor() {
  var swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper.el.style.cursor = '';
}


// WEBPACK FOOTER //
// ./node_modules/swiper/esm/components/core/grab-cursor/unsetGrabCursor.js